import {useEffect, useState} from "react";
import Validator from "../Validator";
import {RoutingHelper} from "../../Navigation/Routing";

function Checkbox({title, value, setValue, initialError, updateObject, id, required}) {
    const [error, setError] = useState(initialError);
    useEffect(() => {setError(initialError);}, [initialError]);

    function handleChange(event) {
        if (typeof setValue === 'function') {
            setValue(event.target.checked);
        }

        validate(event.target.checked);

        if (typeof updateObject === 'function') {
            updateObject(id, event.target.checked);
        }
    }

    function validate(checked) {
        setError(Validator.validateField(checked, id, required, "checkbox"));
    }

    return (
        <>
            <div className="flex items-center">
                <input id={id} type="checkbox" checked={value} onChange={handleChange}
                       className="w-4 h-4 text-red-400 bg-gray-100 border-gray-300 rounded-sm"/>
                <label htmlFor={id} className="ms-2 text-sm font-medium text-primary">
                    {typeof title === "undefined" ?
                        (<>J'accepte les <a rel="noreferrer"
                            href={RoutingHelper.getPath("conditions-generales")} target="_blank"
                            className="text-primary-light hover:underline">
                            conditions générales d'utilisation
                        </a> et la <a rel="noreferrer"
                            href={RoutingHelper.getPath("politique-confidentialite")} target="_blank"
                            className="text-primary-light hover:underline">
                            politique de confidentialité
                        </a>.</>)
                        : title}{required && "*"}
                </label>

            </div>
            {error ?
                (
                    <p className="mt-0 text-xs text-red-600 font-medium">{error}</p>
                )
                : ""}
        </>
    );
}

export default Checkbox;